import { render } from "./exwaregoodslist.vue?vue&type=template&id=22c994ab"
import script from "./exwaregoodslist.vue?vue&type=script&lang=js"
export * from "./exwaregoodslist.vue?vue&type=script&lang=js"

import exportComponent from "F:\\ffile\\vscodeprj\\app\\sal_appgd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__